import { Navigate, useLocation } from 'react-router-dom';
import React, { useEffect } from 'react';
import { useAuthStore } from '../../../store/authStore';
import { useSendSnapchat } from '../../../apiHooks/mutations/integrationMutations/snapchatMutation';

const SnapchatRoute = () => {
  const { isLoggedIn } = useAuthStore();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const codeParam = queryParams.get('code');
  const { mutateAsync: sendSnapchatCode } = useSendSnapchat();

  useEffect(() => {
    if (codeParam && isLoggedIn) {
      sendSnapchatCode(codeParam).then(() => {});
    }
  }, [isLoggedIn]);

  if (isLoggedIn) {
    return <Navigate to="/dashboard" />;
  }

  return <Navigate to="/auth" />;
};

export default SnapchatRoute;
